const ytAccountLinking = {
  'YouTube Shopping Account Linking Title': 'YouTube Shopping Account Linking',
  'Store Setup Title': '1. Shop Preparation',
  'Store Setup Description':
    'Please make sure you can manage your product ads in Google Merchant Center. Then, proceed to Step 2 to copy the connection link and share it with the YouTube Channel owner you‘re collaborating with.',
  'Store Setup GMC Title': 'Connect to Google Merchant Center',
  'Store Setup GMC Description':
    'After the connection, you will be able to upload shop products to your Google Merchant Center account. Please avoid changing the GMC account after completing the YouTube Channel account linking, as you will need to reauthorize the account linking to update product information on the channel. <KnowMoreLink></KnowMoreLink>',
  'Learn More': 'Learn more',
  'Setup Now': 'Setup Now',
  'Store Setup GMC Account Connected':
    'The shop has been connected to below Google Merchant Center account',
  'Store Setup GMC Finished': 'Connected',
  'Store Setup GMC ID Changed':
    'The GMC account has been changed, so some of the linked channels will need to be reauthorized.',
  'Store Setup Content API Title': 'Enable Content API',
  'Store Setup Content API Description':
    'Through the Content API, product updates will be synced to GMC simultaneously, and hidden product information can also be synced to GMC. <KnowMoreLink></KnowMoreLink>',
  'Store Setup Content API Status': 'Google Content API Connection Status',
  'Store Setup Content API Finished': 'Connected',
  'Connected Channels Title':
    '2. YouTube Shopping Account Linking Channel List',
  'Connected Channels Description':
    'Please share the copied link with the manager of the YouTube channel you are collaborating with. Once they have completed the authorization, the channel will gain access to utilize the products created by the shop.',
  'Connected Channels Copy Link': 'Copy Link',
  'Connected Channels Copy Success': 'Copied',
  'Connected Channels No Channels Connected':
    'You have not established any YouTube Shopping account linking with the shop.',
  'Connected Channels Channels Connected':
    'The following channels have linked their accounts with the shop',
  'Connected Channels Not Authorized': 'Not authorized through account linking',
  'Connected Channels Disconnect Tooltip':
    'If you need to disconnect the channel, please contact your customer success specialist.',
  'Connected Channels Disconnect Channel': 'Disconnect',
  'Connected Channels Disconnect Popup Title':
    'Do you confirm the disconnection of the YouTube Shopping account linking between this channel and the shop?',
  'Connected Channels Disconnect Popup Description':
    'After the disconnection, the channel will no longer have access to the shop products.',
  'Connected Channels Cancel Disconnect': 'Cancel',
  'Connected Channels Confirm Disconnect': 'Disconnect',
  'Connected Channels Disconnect Channel Success': 'Disconnected',
  'Connected Channels Reconnect as GMC ID Changed':
    'The GMC account has been changed, please reauthorize the channel.',
};

export default ytAccountLinking;
